module.exports = __webpack_public_path__ + "img/share-icon.ddd2b1d8.svg";